export enum SalesInvoiceEditorTabs {
  BASIC_DATA = 'Dane podstawowe',
  MEDIAPLAN_POSITIONS = 'estimateItemInvoiceTabTitle',
  INVOICE_POSITIONS = 'Pozycje faktury',
  SUMMARY = 'Podsumowanie',
}
